import Vue from 'vue'

// 同级global文件夹下自动注册
const componentsContext = require.context('./global', true, /\.vue$/)
componentsContext.keys().forEach(component => {
    //* 获取文件中的 default 模块，全局组件必须要声明name平常没有这习惯此处标记
    const componentConfig = componentsContext(component).default
    Vue.component(componentConfig.name, componentConfig)
})

//? 不用Vue.use() 模式;
// export default {
//     install (Vue, options) {
//         Object.keys(components).forEach(key => {
//             Vue.component(key, components[key])
//         })
//     }
// }

// require.context(directory, useSubdirectories, regExp)
// directory: 要查找的文件路径
// useSubdirectories: 是否查找子目录
// regExp: 要匹配文件的正则

// global 如果使用还要有二级目录可以加入查找子目录，然后子目录中统一使用`index.vue`，正则可以替换成`/\index.vue$/`用来区分多个vue文件的组件